"use strict";
/* globals module */
/**
 * @module mediaVaultProcessingProviderSettingsRoute
 * @description Baasic Media Vault Processing Provider Settings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Vault Processing Provider Settings Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var contracts_1 = require("../../core/contracts");
var MediaVaultProcessingProviderSettingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaVaultProcessingProviderSettingsRoute, _super);
    function MediaVaultProcessingProviderSettingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'media-vault-preprocessing-settings/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'media-vault-settings';
        _this.updateRoute = 'media-vault-preprocessing-settings/{id}';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing media vault processing provider setting properties using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain media vault processing provider setting subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the media vault processing provider setting property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example mediaVaultProcessingProviderSettingsRoute.find({searchQuery: '<search-phrase>'});
     **/
    MediaVaultProcessingProviderSettingsRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route should be expanded with Id of the media vault processing provider setting resource.
     * @method
     * @example mediaVaultProcessingProviderSettingsRoute.get({id: '<id>'});
     **/
    MediaVaultProcessingProviderSettingsRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update route; this route should be expanded with Id of the media vault processing provider setting resource.
     * @method
     * @param data A media vault preprocessing provider settings object used to update specified media vault preprocessing provider settings in the system.
     * @example mediaVaultProcessingProviderSettingsRoute.update(data);
     **/
    MediaVaultProcessingProviderSettingsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    MediaVaultProcessingProviderSettingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MediaVaultProcessingProviderSettingsRoute);
    return MediaVaultProcessingProviderSettingsRoute;
}(common_1.BaseRoute));
exports.MediaVaultProcessingProviderSettingsRoute = MediaVaultProcessingProviderSettingsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
